export default __webpack_public_path__ + "static/media/picture_banner_01.721f65cd.png";